import Head from "next/head"
import styles from "@/styles/business-development.module.scss"
import DefaultLayout from "@/components/DefaultLayout"
import { Image, Pagination, Row, } from "antd"

import getConfig from 'next/config'
import { useEffect, useRef, useState } from 'react';
import ObserverSection from "@/components/ObserverSection"
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

export default function BusinessDevelopment() {

  const [advantagesActived, setAdvantagesActived] = useState(1)
  const [advantagesList, setAdvantagesList] = useState([{
    id: 1,
    title: '全球资源',
    content: '全球多个国家的品牌/项目资源沉淀与整合能力',
  }, {
    id: 2,
    title: '专业团队',
    content: '专业的产品研发团队与市场营销团队',
  }, {
    id: 3,
    title: '行业经验',
    content: '二十多年的进出口跨境渠道与自营平台的运营管理经验',
  }, {
    id: 4,
    title: '高效管理',
    content: '数字化管理日趋成熟'
  }])

  const [inView, setInView] = useState(false);
  const imageRef = useRef(null);

  useEffect(() => {
    // 创建 IntersectionObserver 实例
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          setInView(true);  // 当图片进入视口时，设置 inView 为 true
        } else {
          setInView(false); // 图片离开视口时，重新设置为 false
        }
      },
      { threshold: 0.2 }  // 20% 可见时触发
    );

    // 监听图片元素
    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    // 清除 observer
    return () => {
      if (imageRef.current) {
        observer.unobserve(imageRef.current);
      }
    };
  }, []);


  const numbersData = [
    { id: 1, start: 0, end: 17, numDesc: '大品类', content: "自主开发" },  // 第一组
    { id: 2, start: 0, end: 900, numDesc: '+', content: "细分品类" },   // 第二组
    { id: 3, start: 0, end: 100000, numDesc: '+', content: "SKU" }   // 第三组
  ];

  const [counts, setCounts] = useState(numbersData.map(num => num.start));  // 存储每组的当前值
  const numberRefs = useRef([]);  // 用于存储多个数字元素的引用

  useEffect(() => {
    const observers: any = [];

    numbersData.forEach((data, index) => {
      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (entry.isIntersecting) {
            let start = data.start;
            const end = data.end;
            const duration = 1000 * (index + 1); // 完成时间
            const increment = end / (duration / 16); // 每帧增加的数量（假设60fps）

            const updateNumber = () => {
              start += increment;
              if (start < end) {
                setCounts((prev) => {
                  const newCounts = [...prev];
                  newCounts[index] = Math.floor(start);
                  return newCounts;
                });
                requestAnimationFrame(updateNumber);
              } else {
                setCounts((prev) => {
                  const newCounts = [...prev];
                  newCounts[index] = end; // 保证最终达到结束值
                  return newCounts;
                });
              }
            };
            requestAnimationFrame(updateNumber);
          }
        },
        { threshold: 0.5 } // 50% 可见时触发
      );

      // 观察每个数字的 DOM 元素
      if (numberRefs.current[index]) {
        observer.observe(numberRefs.current[index]);
      }

      observers.push(observer);  // 存储观察器
    });

    // 清除观察器
    return () => {
      observers.forEach((observer: any, index: any) => {
        if (numberRefs.current[index]) {
          observer.unobserve(numberRefs.current[index]);
        }
      });
    };
  }, []);

  const handleCorporateAdd = () => {
    console.log('add');

    setTimeout(() => {
      const icon = document.querySelector<HTMLImageElement>(`#textBox`);

      if (icon) {
        // 先把 opacity 从 0 调整为 1
        icon.style.opacity = '1';
        // 然后添加动画类名
        icon.classList.add('animate__animated', 'animate__fadeIn');
      }
    }, 250);

    setTimeout(() => {
      const icon = document.querySelector<HTMLImageElement>(`#locationMap img`);

      if (icon) {
        // 先把 opacity 从 0 调整为 1
        icon.style.opacity = '1';
        // 然后添加动画类名
        icon.classList.add('animate__animated', 'animate__fadeIn');
      }
    }, 250);

    setTimeout(() => {
      const icon = document.querySelector<HTMLImageElement>(`#corporateAirplane img`);

      if (icon) {
        // 先把 opacity 从 0 调整为 1
        icon.style.opacity = '1';
        // 然后添加动画类名
        icon.classList.add('animate__animated', 'animate__fadeInBottomRight');
      }
    }, 2000);

    setTimeout(() => {
      const icon = document.querySelector<HTMLImageElement>(`#corporateTruck img`);

      if (icon) {
        // 先把 opacity 从 0 调整为 1
        icon.style.opacity = '1';
        // 然后添加动画类名
        icon.classList.add('animate__animated', 'animate__fadeInLeft');
      }
    }, 750);

    setTimeout(() => {
      const icon = document.querySelector<HTMLImageElement>(`#corporateShip img`);

      if (icon) {
        // 先把 opacity 从 0 调整为 1
        icon.style.opacity = '1';
        // 然后添加动画类名
        icon.classList.add('animate__animated', 'animate__fadeInRight');
      }
    }, 1500);
  };

  const handleCorporateRemove = () => {
    console.log('remove');

    setTimeout(() => {
      const icon = document.querySelector<HTMLImageElement>(`#textBox`);

      if (icon) {
        // 先把 opacity 从 1 调整为 0
        icon.style.opacity = '0';
        // 然后添加动画类名
        icon.classList.remove('animate__animated', 'animate__fadeIn');
      }
    }, 0);

    setTimeout(() => {
      const icon = document.querySelector<HTMLImageElement>(`#locationMap img`);

      if (icon) {
        // 先把 opacity 从 1 调整为 0
        icon.style.opacity = '0';
        // 然后添加动画类名
        icon.classList.remove('animate__animated', 'animate__fadeIn');
      }
    }, 0);

    setTimeout(() => {
      const icon = document.querySelector<HTMLImageElement>(`#corporateAirplane img`);

      if (icon) {
        // 先把 opacity 从 1 调整为 0
        icon.style.opacity = '0';
        // 然后添加动画类名
        icon.classList.remove('animate__animated', 'animate__fadeInBottomRight');
      }
    }, 0);

    setTimeout(() => {
      const icon = document.querySelector<HTMLImageElement>(`#corporateTruck img`);

      if (icon) {
        // 先把 opacity 从 1 调整为 0
        icon.style.opacity = '0';
        // 然后添加动画类名
        icon.classList.remove('animate__animated', 'animate__fadeInLeft');
      }
    }, 0);

    setTimeout(() => {
      const icon = document.querySelector<HTMLImageElement>(`#corporateShip img`);

      if (icon) {
        // 先把 opacity 从 1 调整为 0
        icon.style.opacity = '0';
        // 然后添加动画类名
        icon.classList.remove('animate__animated', 'animate__fadeInRight');
      }
    }, 0);
  };

  return (
    <>
      <Head>
        <title>
          广州市杰钡利科技有限公司
        </title>

        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazysales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        />
        <meta
          name="description"
          content="Australia's #1 online shopping website! Cheap bargains & discounts with the top online shopping Australia store! From furniture, to toys & hobbies, to appliances & pet supplies -- we've got it all, with free shipping on selected items!"
        />
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css" />
      </Head>
      <DefaultLayout>
        <div className={styles['business-development']}>
          <div className={styles['banner-box']}>
            <Image
              className={styles['banner']}
              alt={'banner'}
              width={'100%'}
              style={{ minWidth: 1200 }}
              src={`${imageDomain}/banner/business-development.png`}
              preview={false}
            />

            {/* <div className={styles['banner-title']}>
              <div className={styles['language-english']}>Business Development</div>
              <div className={styles['language-chinese']}>业务发展</div>
            </div> */}
          </div>
          <div className={styles['main']}>
            {/* 优势 */}
            <div className={styles["advantages"]}>
              <ObserverSection customClassName="fade-in">
                <div className={styles['sub-title']}>
                  <div className={styles['language-english']}>Advantages</div>
                  <div className={styles['language-chinese']}>公司优势</div>
                </div>

                <div className={styles['advantages-main']}>
                  <div className={styles['advantages-list']}>
                    {
                      advantagesList.map((item: any) => (
                        <div className={`${styles['advantages-list-item']}`} key={item.id} onClick={() => { setAdvantagesActived(item.id) }}>
                          <div className={styles['advantages-list-item-title']}>{item.title}</div>
                          <div className={styles['advantages-list-item-content']}>{item.content}</div>
                        </div>
                      ))
                    }
                  </div>
                </div>

                <div className={styles['advantages-desc']}>基于公司的战略目标与发展理念，CS一直保持创业的初心与状态，致力于通过自身优势实现共享全球优质产品的使命。</div>
              </ObserverSection>

              <div className={styles['corporate']}>
                <ObserverSection customClassName="fade-in">
                  <div className={styles['sub-title']}>
                    <div className={styles['language-english']}>Business Scope</div>
                    <div className={styles['language-chinese']}>业务范围</div>
                  </div>
                </ObserverSection>
                <div className={styles['corporate-main']} >
                  <Image
                    className={styles['corporate-bg']}
                    src={`${imageDomain}/business/business-corporate-bg.png`}
                    width="100%"
                    preview={false}
                  />
                  <ObserverSection
                    customClassName={styles['corporate-content-static']}
                    onAdd={handleCorporateAdd}
                    onRemove={handleCorporateRemove}
                  >
                    <div className={styles['corporate-content']}>
                      <div className={styles['text-box']} id="textBox">
                        <div className={styles['text-box-title']}>跨境出口零售</div>
                        <div className={styles['text-box-content']}>依托自主品牌+自建平台+自建ERP+自营海外仓，通过Crazysales垂直站和Amazon、Walmart、AliExpress、Mercado Libre、eBay等数十个全球知名电商平台为载体，推动民族品牌出海，向国内外C端消费者提供优质产品，销售覆盖多个国家和地区，包括澳大利亚、新西兰、美国。中东等。</div>
                      </div>

                      <div className={styles['corporate-animate-box']}>
                        <Image
                          className={styles['corporate-animate-box-bg']}
                          src={`${imageDomain}/business/business-corporate-earth-bg.png`}
                          width="100%"
                          preview={false}
                        />

                        <Image
                          className={styles['corporate-location-map']}
                          src={`${imageDomain}/business/location-map.png`}
                          width="100%"
                          preview={false}
                          id="locationMap"
                        />

                        <Image
                          className={styles['corporate-airplane']}
                          src={`${imageDomain}/business/airplane.png`}
                          width="100%"
                          preview={false}
                          id="corporateAirplane"
                        />

                        <Image
                          className={styles['corporate-truck']}
                          src={`${imageDomain}/business/truck.png`}
                          width="100%"
                          preview={false}
                          id="corporateTruck"
                        />

                        <Image
                          className={styles['corporate-ship']}
                          src={`${imageDomain}/business/ship.png`}
                          width="100%"
                          preview={false}
                          id="corporateShip"
                        />
                      </div>
                    </div>
                  </ObserverSection>
                </div>
              </div>

              <div className={styles['product-category']}>
                <ObserverSection customClassName="fade-in">
                  <>
                    <div className={styles['sub-title']}>
                      <div className={styles['language-english']}>Product Category</div>
                      <div className={styles['language-chinese']}>产品品类</div>
                    </div>
                    <div className={styles['product-category-desc']}>出口部主营产品涵盖生活家居、健身器材、家用电器、儿童玩具、3C科技、运动户外、宠物用品等全领域品类拓展；齐全的类目和丰富的产品为客户提供优质的购物体验。</div>
                  </>
                </ObserverSection>
                <div className={styles['product-category-background']} ref={imageRef}>
                  <div className={`${styles['product-category-statistics']} ${styles['max-width']}`}>
                    {
                      numbersData.map((item: any, index: number) => (
                        <div className={styles['product-category-statistics-item']} key={item.id}>
                          <div className={styles['product-category-statistics-item-title']}><span ref={(el: never) => (numberRefs.current[index] = el)}>{counts[index]}</span>{item.numDesc}</div>
                          <div className={styles['product-category-statistics-item-content']}>{item.content}</div>
                        </div>
                      ))
                    }
                  </div>

                  <div className={`${styles['product-category-statistics-icon']} ${inView ? styles['fade-in'] : ''}`}>
                    <Image src={`${imageDomain}/business/top-allow.png`} height="100%" preview={false} />
                  </div>
                </div>
              </div>

              <div className={`${styles['cooperative-partner']} ${styles['max-width']}`}>
                <div className={styles['sub-title']} style={{ marginBottom: 20 }}>
                  <div className={styles['language-english']}>Own Brands</div>
                  <div className={styles['language-chinese']}>自有品牌</div>
                </div>
                <div className={styles['cooperative-partner-list']}>
                  <div className={styles['cooperative-partner-list-line']} style={{ justifyContent: "space-around" }}>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/Acouxtro -logo.png`} height="80px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/Ailink-logo.png`} height="55px" preview={false} />
                    </div>
                    {/* <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/Clatterans -logo.png`} height="60px" preview={false} />
                    </div> */}
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/Dashoto-Logo.png`} height="41px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/Dr Fussy-logo.png`} height="67px" preview={false} />
                    </div>
                  </div>
                  <div className={styles['cooperative-partner-list-line']}>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/DR.REPEL -LOGO.png`} height="63px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/OGL-logo.png`} height="67px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/buon-viaggio.png`} height="54px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/Luxdream-2-logo.png`} height="92px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/Slight-logo.png`} height="73px" preview={false} />
                    </div>
                  </div>
                  <div className={styles['cooperative-partner-list-line']}>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/Luxsuite-logo.png`} height="62px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/GENKI-logo.png`} height="67px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/Aqua-Optio.png`} height="75px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/Melodic-logo.png`} height="67px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/Homcrave--LOGO.png`} height="50px" preview={false} />
                    </div>
                  </div>
                  <div className={styles['cooperative-partner-list-line']}>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/Pet Scene_logo.png`} height="73px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/HOMASA.png`} height="29px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/ninesi.png`} height="54px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/SHOGUN-logo.png`} height="45px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/lantark-C.png`} height="42px" preview={false} />
                    </div>
                  </div>
                  <div className={styles['cooperative-partner-list-line']}>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/NEADER.png`} height="34px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/MAXKON-logo.png`} height="34px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/on-fille.png`} height="45px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/KIDBOT.png`} height="84px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/AUSWHEEL.png`} height="41px" preview={false} />
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles['cooperative-partner']} ${styles['max-width']}`}>
                <div className={styles['sub-title']} style={{ marginBottom: 20 }}>
                  <div className={styles['language-english']}>Self-Operated Platforms</div>
                  <div className={styles['language-chinese']}>自营平台</div>
                </div>
                <div className={styles['cooperative-partner-list']}>
                  <div className={styles['cooperative-partner-list-line']} style={{ justifyContent: "center" }}>
                    <div className={styles['cooperative-partner-list-item']} style={{ marginRight: '70px' }}>
                      <Image src={`${imageDomain}/business/logo/crazysales-logo.png`} height="58px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/bd-logo.png`} height="52px" preview={false} />
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles['cooperative-partner']} ${styles['max-width']}`}>
                <div className={styles['sub-title']} style={{ marginBottom: 20 }}>
                  <div className={styles['language-english']}>Collaboration Platforms</div>
                  <div className={styles['language-chinese']}>合作平台</div>
                </div>
                <div className={styles['cooperative-partner-list']} style={{ marginBottom: '0' }}>
                  <div className={styles['cooperative-partner-list-line']} style={{ justifyContent: 'space-around' }}>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/temu-logo.png`} height="52px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/ebay-LOGO.png`} height="56px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/amazon.png`} height="48px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/kogan-logo.png`} height="58px" preview={false} />
                    </div>
                  </div>
                </div>

                <div className={styles['cooperative-partner-list']} style={{ marginBottom: '0' }}>
                  <div className={styles['cooperative-partner-list-line']} style={{ justifyContent: 'space-around' }}>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/home/until-gone-logo.png`} height="66px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/home/wool-worths-logo.png`} height="47px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/home/harvery-norman-logo.png`} height="31px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/home/my-sale-logo.png`} height="46px" preview={false} />
                    </div>
                  </div>
                </div>

                <div className={styles['cooperative-partner-list']}>
                  <div className={styles['cooperative-partner-list-line']} style={{ justifyContent: 'space-around' }}>
                    <div className={styles['cooperative-partner-list-item']} style={{ margin: '0 40px' }}>
                      <Image src={`${imageDomain}/home/the-warehouse-logo.png`} height="52px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/home/bunnings-warehouse-logo.png`} height="49px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/Mydeal-logo.png`} height="46px" preview={false} />
                    </div>
                    <div className={styles['cooperative-partner-list-item']}>
                      <Image src={`${imageDomain}/business/logo/catch.png`} height="57px" preview={false} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </DefaultLayout>
    </>
  )
}